module.exports = require('../../full/symbol');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/symbol/index.js
// module id = 1332
// module chunks = 25